export default "__VITE_ASSET__5bQ2llHX__"